import { createContext } from "react";

type ScrollContextType = {
    contentRef: React.RefObject<HTMLDivElement> | undefined;
    scrollToTop: (behavior?: ScrollBehavior) => void;
} | null;

const ScrollContext = createContext<ScrollContextType>(null);

export { ScrollContext };